import { render, staticRenderFns } from "./comp_ProductImagesDialog.vue?vue&type=template&id=1352a93e&scoped=true&"
import script from "./comp_ProductImagesDialog.vue?vue&type=script&lang=js&"
export * from "./comp_ProductImagesDialog.vue?vue&type=script&lang=js&"
import style0 from "./comp_ProductImagesDialog.vue?vue&type=style&index=0&id=1352a93e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1352a93e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDialog,VIcon,VProgressCircular,VRow})
